import { render, staticRenderFns } from "./FoodGroceriesTable.vue?vue&type=template&id=7c0a44b6"
import script from "./FoodGroceriesTable.vue?vue&type=script&lang=js"
export * from "./FoodGroceriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports